// @noflow
import {
    getCopyDay,
    getDataId,
    getDayScheduleEvents,
    getScheduleMode,
    getSelectedDay
} from '~/core/state/ui/schedule/selectors';

import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { getPropsForProduct } from '~/core/state/products/selectors';
import MessagesBar from './component';
import { scheduleModesEnum } from '~/core/constants/schedule';

const mapStateToProps = (state, { componentId }) => {
    const scheduleMode = getScheduleMode(state, { componentId });
    const isAddMode = scheduleMode === scheduleModesEnum.ADD_EVENT;
    const isCopyMode = scheduleMode === scheduleModesEnum.COPY_DAY;
    const isDeleteMode = scheduleMode === scheduleModesEnum.DELETE_EVENT;

    const selectedDay = getSelectedDay(state, { componentId });
    const isADaySelected = selectedDay !== null;
    const numEventsInSelectedDay = isADaySelected
        ? getDayScheduleEvents(state, {
              componentId,
              dayIndex: selectedDay
          }).size - 1
        : null;
    const productId = getDataId(state, { componentId });
    const maxEvents = (getPropsForProduct(state, { id: productId }) || fromJS({})).get('maxEvents', 6);
    const isMaxEventsReached = numEventsInSelectedDay >= maxEvents;

    const isADaySelectedToBeCopyFrom = getCopyDay(state, { componentId }) !== null;

    const isMinEventsReached = numEventsInSelectedDay <= 1;

    const messageId = {
        [true]: null,
        [isAddMode]: 'addEvent',
        [isAddMode && isADaySelected]: 'addEventSelectedDay',
        [isAddMode && isADaySelected && isMaxEventsReached]: 'addEventMaxEvents',
        [isCopyMode]: 'copyDayEventsCopyFrom',
        [isCopyMode && isADaySelectedToBeCopyFrom]: 'copyDayEventsCopyTo',
        [isDeleteMode]: 'deleteEvent',
        [isDeleteMode && isADaySelected]: 'deleteEventSelectedDay',
        [isDeleteMode && isADaySelected && isMinEventsReached]: 'deleteEventMinEvents'
    }[true];

    return {
        messageId
    };
};

export default connect(mapStateToProps)(MessagesBar);



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/messages-bar/index.js